import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceValidateTimeRecordsUpToDateNotificationState = createStateReducer(
  initialState,
  {
    [events.validateTimeRecordsUpToDateFailed]: (state) => ({
      ...state,
      queue: updateNotification(
        {
          key: "validateTimeRecordsUpToDate",
          flags: ["failure"],
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceValidateTimeRecordsUpToDateNotificationState };
